export default "__VITE_ASSET__OdP8ExNt__"